export default __webpack_public_path__ + "static/HelveticaNeue-CondensedBold-be7b7f513ca81ddc3b4d0568b186d72a.woff2";